<table mat-table [dataSource]="projectsSliced$"
    class="full-width-table striped-table widget-table widget-table-hoverable" aria-label="Tasks">
    <app-table-column name="name" labelT="PROJECTS.cockpit.project-widget.header-title">
        <ng-template let-row>
            <app-project-name-display [project]="row" />
        </ng-template>
    </app-table-column>

    <app-table-column *ngIf="1" name="numbers" labelT="PROJECTS.cockpit.project-widget.header-project-number">
        <ng-template let-row let-index="index" let-projectIndex="dataIndex">
            <app-project-number-display [project]="row" [projectIndex]="projectIndex" [isInternalUser]="isInternalUser"
                (clicked)="numberClicked.emit($event)" />
        </ng-template>
    </app-table-column>

    <app-table-column name="managers" labelT="PROJECTS.cockpit.project-widget.header-created-by">
        <ng-template let-row>
            <span class="project-managers"
                matTooltip="{{ row.projectManagers!.length > 1 ? row.projectManagers.join(', ') : '' }}">
                {{ row.projectManagers.join(', ') }}
            </span>
        </ng-template>
    </app-table-column>

    <app-table-column name="actions">
        <ng-template let-row>
            <div class="action-buttons-container">
                <a *ngIf="row.isAssignedToMe" [href]="row.sharePointLink" target="_blank"
                    matTooltip="{{ 'shared.open' | translate }}"
                    class="open-btn">
                    <mat-icon svgIcon="location-enter_icon"></mat-icon>
                </a>
                <a *appShowAuthorize="'PROJECT_WRITE'; options: { values: { customerSpaceId: row.customerSpaceId, projectId: row.id } }"
                    [routerLink]="['/customer-spaces', row.customerSpaceId, 'projects', row.id, 'admin']"
                    matTooltip="{{ 'shared.edit' | translate }}"
                    class="edit-btn">
                    <mat-icon svgIcon="edit_icon"></mat-icon>
                </a>
            </div>
        </ng-template>
    </app-table-column>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr *matNoDataRow>
        <td style="text-align: center; padding: 20px 0;" [attr.colspan]="displayedColumns.length">
            <mat-icon svgIcon="empty"></mat-icon>
        </td>
    </tr>

</table>